import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@febos-io/design';

import useTranslation from '../hooks/useTranslation';
import OdontogramReport from './OdontogramReport';

export function ListExamElementReport({
  exam
}) {
  const { t } = useTranslation();
  return (
    <ul className="list-group list-group-flush">
      {!!exam.odontogram?.length
        && (
          <li className="list-group-item pt-2">
            <Icon icon="tooth" className="me-2" />
            <strong className="d-inline">
              {t('Teeth')}
            </strong>
            <div className="row mt-1 p-0">
              <OdontogramReport
                isChild={exam.isChild}
                isADA={exam.isADA}
                teeth={exam.odontogram}
              />
            </div>
          </li>
        )
      }
    </ul>
  );
}

export default ListExamElementReport;

ListExamElementReport.propTypes = {
  exam: PropTypes.object
};
